import request from '@/utils/request'
import { IUSerData } from './types'

export const defaultUserData: IUSerData = {
  id: 0,
  name: '',
  roles: '',
  avator: '',
  indroduction: ''
}
export const getUserInfo = (data: any) =>
  request({
    url: '/users/info',
    method: 'post',
    data
  })
export const getUserInfoList = (data: any) =>
  request({
    url: '/users/infoList',
    method: 'post',
    data
  })
export const updateUserInfo = (data: any) =>
  request({
    url: '/users/updateUserInfo',
    method: 'post',
    data
  })
export const login = (data: any) =>
  request({
    url: '/users/login',
    method: 'post',
    data
  })

export const logout = () =>
  request({
    url: '/users/logout',
    method: 'post'
  })
